import { FlowConsumerContextEnergy as FlowContext } from '../../context';

export const shouldSkipWhenUsageNotKnown = (context: FlowContext): boolean => {
  const { isUsageKnown } = context;

  return !isUsageKnown;
};
